import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import { Doughnut } from "react-chartjs-2";

const TimeDonut = () => {
  ChartJS.register(ArcElement, Tooltip, Legend, Title);

  // Based on navigation timing events, see ref table at:
  // https://www.w3.org/TR/navigation-timing-2/#processing-model
  const performanceEntries = performance.getEntriesByType("navigation")[0];

  const wptData = {
    Fetch: performanceEntries.domainLookupStart - performanceEntries.startTime,
    "Domain lookup": performanceEntries.domainLookupEnd - performanceEntries.domainLookupStart,
    Connection: performanceEntries.connectEnd - performanceEntries.domainLookupEnd,
    Request: performanceEntries.responseStart - performanceEntries.connectEnd,
    Response: performanceEntries.responseEnd - performanceEntries.responseStart,
    "DOM Interactive": performanceEntries.domInteractive - performanceEntries.responseEnd,
    "DOM Complete": performanceEntries.domComplete - performanceEntries.domInteractive,
    "Load Event": performanceEntries.loadEventEnd - performanceEntries.domComplete,
  };

  const doughnutData = {
    labels: Object.keys(wptData),
    datasets: [
      {
        data: Object.values(wptData),
        backgroundColor: [
          "rgba(103, 227, 86, 1)",
          "rgba(138, 86, 226, 1)",
          "rgba(208, 86, 226, 1)",
          "rgba(226, 86, 104, 1)",
          "rgba(226, 137, 86, 1)",
          "rgba(226, 207, 86, 1)",
          "rgba(86, 174, 226, 1)",
          "rgba(86, 227, 207, 1)",
        ],
        hoverOffset: 30,
        borderColor: "rgba(0, 0, 0, 0.3)",
        borderWidth: 1,
      },
    ],
  };

  const doughnutOptions = {
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text:
          "Page load timings. Total: " +
          (performanceEntries.loadEventEnd - performanceEntries.startTime).toFixed(1) +
          "ms",
        color: "rgba(255, 255, 255, 0.9)",
        padding: {
          top: 0,
          bottom: 20,
        },
      },
      tooltip: {
        callbacks: {
          title: function (tooltipItems) {
            return tooltipItems.title;
          },
          label: function (tooltipItems) {
            return ` ${tooltipItems.formattedValue}ms`;
          },
        },
      },
    },
    layout: {
      padding: {
        top: 10,
        bottom: 30,
        left: 30,
        right: 30,
      },
    },
  };

  return <Doughnut data={doughnutData} options={doughnutOptions} />;
};

export default TimeDonut;
